import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { createHttpParams } from './utilities';
import { locationOrderApiRequestParams, CreateLocationRequest } from 'src/models/location.model';
import {
  LocationDetails,
  Timezone,
  LocationOrder,
  LocationPreview,
} from 'src/store/location.store';
import { ApiRequestParams } from 'src/models/global-interfaces';

export interface LocationTaskCount {
  count: number;
  color: number;
}

@Injectable()
export class LocationService {
  private apiUrl = environment.apiUrl;
  private readonly http: HttpClient = inject(HttpClient);

  getLocations = (params: ApiRequestParams = locationOrderApiRequestParams) => {
    return this.http.get<LocationPreview[]>(`${this.apiUrl}locations`, {
      params: createHttpParams(params),
    });
  };

  getLocationById = (locationID: number, dataScope?: string) =>
    this.http.get<LocationDetails>(`${this.apiUrl}locations/${locationID}`, {
      params: createHttpParams({ dataScope }),
    });

  createLocation = (params: CreateLocationRequest) =>
    this.http.post<{ id: number; locationName: string; order: number }>(`${this.apiUrl}locations`, {
      ...params,
    });

  deleteLocation = (locationID: number) =>
    this.http.delete<unknown>(`${this.apiUrl}locations/${locationID}`);

  updateLocation = (location: Partial<LocationDetails>) =>
    this.http.put(`${this.apiUrl}locations/${location.id}`, { ...location });

  updateLocationOrder = (locations: LocationOrder[]) =>
    this.http.put<unknown>(`${this.apiUrl}locations/update-location-order`, { locations });

  getTimezones = () => this.http.get<Timezone[]>(`${this.apiUrl}timezone`);

  getLocationTaskCount = (locationID: number) =>
    this.http.get<LocationTaskCount>(`${this.apiUrl}tasks/${locationID}/my-task-count`);
}
